"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageComponents = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsComponents = require("../../components/DmsComponent/DmsComponents");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageComponents Component
 * 
 * @description Component for managing and displaying components within the system. 
 * Renders a DmsPage layout with a DmsAltBox containing the DmsComponents component.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageComponents />
 * )
 * 
 * @returns {JSX.Element} The Components page.
 */
const DmsPageComponents = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Components"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Components").d("Components"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, {
    sx: {
      overflowY: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsComponents.DmsComponents, null))));
};

// Prop types for DmsPageComponents
exports.DmsPageComponents = DmsPageComponents;
DmsPageComponents.propTypes = {
  // If no props are needed, you can define an empty object
  // Otherwise, add your prop types here
};